<script setup lang="ts">
  import { Toaster, useToast } from '@gat-ship/vue-components/toast'
  import { useNotificationStore } from '../store/store-notification'
  import { useTemplateRef, watch } from 'vue'
  import NotificationDialog from './NotificationDialog.vue'
  const notificationStore = useNotificationStore()

  const notificationDialogRef = useTemplateRef('notificationDialog')

  watch(
    () => notificationStore.notifications,
    (newNotifications) => {
      const lastNotification = newNotifications[newNotifications.length - 1]
      if (lastNotification.notificationType === 'toast') {
        useToast().toast({
          title: lastNotification.title,
          description: lastNotification.description,
          icon: lastNotification.icon as IconValues
        })
      } else if (lastNotification.notificationType === 'dialog') {
        notificationDialogRef.value?.showDialog({ ...lastNotification })
      }
    },
    {
      deep: true
    }
  )
</script>
<template>
  <Toaster />
  <slot />
  <NotificationDialog ref="notificationDialog" />
</template>
